export const hasNonEmptyKeys = (obj, keys) => {
  return keys.every(key => obj[key] !== null && obj[key] !== undefined && obj[key] !== "");
}
export const truncateFilename = (filename, maxLength = 20) => {
  if (filename.length <= maxLength) return filename;
  const parts = filename.split('.');
  const extension = parts.pop();
  const truncatedName = parts.join('.').slice(0, maxLength - 3 - extension.length) + '...';
  return `${truncatedName}.${extension}`;
};